// Prices Docs
export const pricesDocs = [
  {
    id: 'prices',
    label: 'Prices'
  }
];
